import React from 'react';

import { Container, Row, Col, Heading, className } from 'aplazame-design-system';
import { useTranslate } from 'soluble-gatsby-source';

import HeaderResourcesSection from '../HeaderResourcesSection';
import CardEventComponent from '../CardEventComponent';
import CardFutureWebinarComponent from '../CardFutureWebinarComponent';


import colorStyle from "aplazame-design-system/src/scss/color.module.scss";


export default function EventsSection({
    title,
    subtitle,
    futureEvents,
    pastEvents
}) {
    const translation = useTranslate();

    return (
        <div role="region">
            <HeaderResourcesSection
                title={title}
                subtitle={subtitle}
            />
            {futureEvents && futureEvents.length ? (
                <section
                    {...className(`mt-lg-1 ${colorStyle['bg--tertiary']}`)}
                >
                    <Container
                        pt={{ xs: 4, lg: 8 }}
                        pb={{
                            xs: pastEvents && pastEvents.length ? 3 : 7,
                            lg: pastEvents && pastEvents.length ? 7 : 15
                        }}
                    >
                        <Row>
                            <Col
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                                style={{
                                    "--sal-delay": `1200ms`
                                }}
                            >
                                <Heading
                                    tag="h3"
                                    mb={{ xs: 4, lg: 5 }}
                                    className="h3 font-weight-bold"
                                >
                                    {translation['events-section.next.title'].text}
                                </Heading>
                            </Col>
                        </Row>
                        {futureEvents.map((event, i) => (
                            <CardFutureWebinarComponent
                                key={i}
                                isFirstViewport={true}
                                {...event}
                                isEvent={true}
                            />
                        ))}
                    </Container>
                </section>
            ) : null}
            {pastEvents && pastEvents.length ? (
                <section>
                    <Container
                        pt={{
                            xs: futureEvents && futureEvents.length ? 7 : 2,
                            lg: futureEvents && futureEvents.length ? 14 : 2
                        }}
                        pb={{ xs: 6, lg: 11 }}
                    >
                        <Row>
                            <Col>
                                <Heading
                                    tag="h3"
                                    mb={{ xs: 7, lg: 8 }}
                                    className="h3 font-weight-bold"
                                    data-sal="slide-up"
                                    data-sal-easing="ease-out-quart"
                                    style={{
                                        "--sal-delay": futureEvents && futureEvents.length ? '' : `1200ms`
                                    }}
                                >
                                    {translation['events-section.past.title'].text}
                                </Heading>
                            </Col>
                            {pastEvents.map((event, i) => (
                                <Col
                                    key={i}
                                    col={{ md: 6, lg: 4 }}
                                    pb={{ xs: 7, lg: 3 }}
                                    data-sal="slide-up"
                                    data-sal-easing="ease-out-quart"
                                    data-sal-delay={`xs-none--lg-${(i % 3) * 100}`}
                                >
                                    <CardEventComponent
                                        {...event}
                                    />
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>
            ) : null}
        </div>
    );
}